import * as React from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const LoadingAppointment = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "60px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "40%",
        height: "15px",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "25%",
        height: "15px",
        rx: "5",
        fill: "currentColor",
        y: "30"
    })));
};
LoadingAppointment.displayName = 'LoadingAppointment';

export { LoadingAppointment, LoadingAppointment as default };
//# sourceMappingURL=Loading.js.map
